
import SimpleHeader from "components/Headers/SimpleHeader.jsx";
import React from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Container,
  Form
} from "reactstrap";
import TenantService from "../../../services/tenantService";
import TenantForm from "./Form";

class TenantCreate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errorData: {}
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  handleSubmit(event) {
    event.preventDefault();
    TenantService.create(this.state).then(response => {
      if (response.responseStatus === "SUCCESS") {
        this.props.history.push("/superAdmin/tenant/list");
      } else {
        this.setState({ errorData: response.data });
        console.error("Error    ==>     " + response.message);
      }
    });
  }

  render() {
    return (
      <>
        <SimpleHeader
            name="Create"
            parentName="Tenant"
            heading="ClashMate"
            newBtnUrl="/superAdmin/tenant/create"
            newBtnText="Create Tenant"
        />
        <Container className="mt--6" fluid>
          <Card className="mb-4">
            <CardHeader>
              <h3 className="mb-0">Create Tenant</h3>
            </CardHeader>
            <CardBody>
              <Form role="form" onSubmit={this.handleSubmit}>
                <TenantForm
                  onChange={this.handleChange}
                  valueObj={this.state}
                  errorObj={this.state.errorData}
                  isEdit={false}
                />
                <div className="text-center">
                  <Button className="my-4" color="info" type="submit">
                    Submit
                  </Button>
                </div>
              </Form>
            </CardBody>
          </Card>
        </Container>
      </>
    );
  }
}

export default TenantCreate;
